import clsx from 'clsx';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

const LoaderPropagate: FC<TLoaderPropagate> = ({ className }: { className?: string }) => (
  <span className={twMerge(clsx('relative', className))}>
    {propagate.map((className, i) => (
      <span
        key={i}
        className={twMerge(clsx('absolute h-15 w-15 rounded-[50%] bg-primary-350 text-[45px]', className))}
      />
    ))}
  </span>
);

export default LoaderPropagate;

export type TLoaderPropagate = {
  className?: string;
  size?: number;
  color?: string;
  speedMultiplier?: number;
};

const propagate = [
  'animate-loaderPropogate1',
  'animate-loaderPropogate2',
  'animate-loaderPropogate3',
  'animate-loaderPropogate4',
  'animate-loaderPropogate5',
  'animate-loaderPropogate6',
];
